module.exports = __webpack_public_path__ + "media/images/favicon-791af5f3b7466dbf5d3da76ac1bf291b.ico";